var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07813 2.34544C8.07813 3.42041 7.18417 4.29244 6.08204 4.29244C4.9799 4.29244 4.08594 3.42046 4.08594 2.34544C4.08594 1.26973 4.9799 0.398438 6.08204 0.398438C7.18417 0.398438 8.07813 1.26968 8.07813 2.34544ZM7.27987 2.34544C7.27987 2.98996 6.74365 3.513 6.08209 3.513C5.42054 3.513 4.88432 2.98996 4.88432 2.34544C4.88432 1.70018 5.42054 1.17712 6.08209 1.17712C6.74365 1.17712 7.27987 1.70016 7.27987 2.34544Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09942 10.3445C5.3794 10.3445 4.87963 10.8394 4.87963 11.355H4.08594C4.08594 10.3267 5.03382 9.57031 6.09934 9.57031C7.16486 9.57031 8.11274 10.3267 8.11274 11.355H7.31905C7.31905 10.8394 6.81944 10.3445 6.09942 10.3445Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09462 8.80543C5.19383 8.80543 4.47456 9.0825 4.1411 9.4144C3.98768 9.56701 3.73628 9.56923 3.57982 9.41958C3.42336 9.26993 3.42108 9.02546 3.5745 8.87211C4.10921 8.34018 5.06849 8.03125 6.09461 8.03125C7.12148 8.03125 8.08079 8.34018 8.6155 8.87211C8.76892 9.02546 8.76588 9.26995 8.60942 9.41958C8.45296 9.56923 8.20155 9.56701 8.04814 9.4144C7.71472 9.0825 6.99619 8.80543 6.09462 8.80543Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09451 7.26638C5.43222 7.26638 4.85497 7.41751 4.46306 7.63901C4.27318 7.74569 4.03013 7.68272 3.92075 7.49751C3.81062 7.3123 3.87594 7.07597 4.06506 6.96854C4.60053 6.66703 5.32055 6.49219 6.0946 6.49219C6.86866 6.49219 7.58934 6.66703 8.12415 6.96854C8.31403 7.07597 8.37859 7.3123 8.26921 7.49751C8.15908 7.68272 7.9168 7.7457 7.72691 7.63901C7.33424 7.4175 6.7568 7.26638 6.09451 7.26638Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65625 9.92648V5.48438H6.44995V9.92648H5.65625Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.53125 5.88039C0.53125 5.23882 1.06444 4.71875 1.72142 4.71875H10.4832C11.1409 4.71875 11.6741 5.23882 11.6741 5.88039V10.5795C11.6741 11.2203 11.1409 11.7404 10.4832 11.7404H1.72142C1.06444 11.7404 0.53125 11.2203 0.53125 10.5795V5.88039ZM1.72142 5.49292C1.50268 5.49292 1.32494 5.66628 1.32494 5.88039V10.5795C1.32494 10.7928 1.50267 10.9662 1.72142 10.9662H10.4832C10.7027 10.9662 10.8804 10.7929 10.8804 10.5795V5.88039C10.8804 5.66629 10.7027 5.49292 10.4832 5.49292H1.72142Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterVisitIcon);
export default __webpack_public_path__ + "static/media/CenterVisitIcon.897464631471ac9b38aa211fc1c2fa6d.svg";
export { ForwardRef as ReactComponent };